import projectConfig from '@/core/config';

import {
  sysDocExtControl_listByType,
  sysEntityExtControl_listByType,
  sysPrint_getDefaultByModules
} from '@/api/myController/system';
import { getUserInfo } from './index';
import { mulFloat } from '@/utils/myUtils';

let printSingleList = [
  { name: '报价人', value: 'baseQuotationPersonName' },
  { name: '电话', value: 'baseQuotationPersonMobile' },
  { name: '邮箱', value: 'baseQuotationPersonEmail' },
  { name: '地址', value: '' },
  { name: '客户名称', value: 'baseCustomerName' },
  { name: '客户电话', value: 'baseCustomerPhone' },
  { name: '制单人', value: 'creatorName' },
  { name: '客户地址', value: 'baseCustomerAddress' },
  { name: '联系人', value: 'baseCustomerContactsName' },
  { name: '日期', value: 'baseQuotationTime' },
  { name: '金额合计', value: 'valueTotalAmountWords' },
  { name: '小写金额', value: 'valueTotalAmountFigures' },
  { name: '交货时间', value: 'baseDeliveryTime' },
  { name: '付款方式', value: 'valuePaymentModel' },
  { name: '运输方式', value: 'valueTransportModel' },
  { name: '报价单名称', value: 'docName' },
  { name: '样品创建人', value: 'baseSamplePersonName' },
  { name: '样品单名称', value: 'docName' }
]
let printKeyList = [
  { name: '产品图片', value: 'baseImgUrl' },
  { name: '产品名称', value: 'baseMaterialName' },
  { name: '单位', value: 'baseMaterialUnitName' },
  { name: '数量', value: 'baseAmount' },
  { name: '交货时间', value: 'baseDeliveryTime' },
  { name: '单价', value: 'baseMaterialUnitprice' },
  { name: '金额', value: 'baseMaterialTotalprice' },
  { name: '备注', value: 'remark' }
]
var huipu = {
  // companyName: "上海清埔减震器制造有限公司",
  // companyId: "91 310 120 350 880 9419",
  // companyAddress: "上海市崇明区长兴镇江南大道1333弄11号3810室",
  // companyPhone: "021-59181655",
  // companyBank: "中国农业银行股份有限公司上海南翔支行",
  // companyBankNumber: "0380 6800 0401 08021",
  // companyPaperAddress: "上海市嘉定区博学南路713号M3高新产业园",
  // companyWeb: "www.sh-sqz.com",
  // companyLogo: "http://120.77.178.101:19000/application/1722158011310407743/qingguang/attachment/7ef86651ac8847da96a5c3c3b94cbedc.png",
  // companyChapter: "http://120.77.178.101:19000/application/1722158011310407743/qingguang/attachment/c4026bbd28984104bdb8b4c433d42c2b.png",
};

function setCompanyData(str = '') {
  var reg = RegExp(/清埔/);
  if (str.match(reg)) {
    return huipu;
  }
  // return huipu;
}
let userinfo = JSON.parse(getUserInfo());

function getSysEntityExt(list) {
  let extList = [];
  list.forEach((item) => {
    let selectOptionList = [];
    let dataType = 'text';
    switch (item.fieldType) {
      case 0:
        dataType = 'text';
        break;
      case 1:
        dataType = 'customSelect';
        selectOptionList = JSON.parse(item.fieldTypeRelinfo);
        break;
      case 2:
        dataType = 'excel';
        selectOptionList = JSON.parse(item.fieldTypeRelinfo);
        break;
      case 3:
        dataType = 'dateTime';
        break;
      case 4:
        dataType = 'dateTimeV2';
        break;
      case 5:
        dataType = 'fileList';
        break;
      default:
        dataType = 'text';
        break;
    }
    let json = {
      id: item.extControlId,
      name: item.fieldName,
      value: item.fieldTag,
      fixedState: false,
      isShow: true,
      dataType: dataType,
      selectOptionKey: '',
      selectOptionList: selectOptionList,
      alwaysEditState: false,
      canEdit: true,
      width: 120,
      sortable: true
    };
    extList.push(json);
  });
  return extList;
}

function sysSelectDataShow(val, list) {
  if (list) {
    let single = list.filter((item) => {
      return item.value == val;
    });
    return single.length > 0 ? single[0].label : '';
  }
}

function specListShow(list) {
  let text = '';
  try {
    for (let i = 0; i < list.length; i++) {
      let kong = i == list.length - 1 ? '' : '/';
      if (list.length == 1 && list[i].specKey == '规格') { text += list[i].specValue + kong; } else { text += list[i].specKey + ':' + list[i].specValue + kong; }
    }
  } catch (error) { }
  return text;
}

export async function print(that, datas, data) {
  console.log(that.htmlData)
  var model = JSON.parse(JSON.stringify(that.htmlData));
  console.log('that.htmlData', that.htmlData)
  console.log(model)
  data.forEach((item) => {
    try {
      console.log(JSON.parse(item.baseSpecgroupDesc));
      item.specifications = specListShow(JSON.parse(item.baseMaterialSpecDesc));
      item.groupspecifications = specListShow(JSON.parse(item.baseSpecgroupDesc));
    } catch (error) { }
  });
  that.printList = data;
  that.printSingleData = datas;
  that.$nextTick(() => {
    try {
      // 处理主数据
      printSingleList.forEach((item, index) => {
        let name = '{#' + item.name + '}';
        let value = '';
        if (name.indexOf('图片') > -1) {
          value = that.printSingleData[item.value]
            ? "<img style='height:40px' src='" +
            that.showImageUrl +
            that.printSingleData[item.value] +
            "'/>"
            : '';
        } else {
          value =
            that.printSingleData[item.value] ||
              that.printSingleData[item.value] == 0
              ? that.printSingleData[item.value]
              : '';
        }
        that.htmlData = that.htmlData.replaceAll(name, value);
        if (index == printSingleList.length - 1) {
          document.getElementById('printTable').innerHTML = that.htmlData;
          that.htmlData = JSON.parse(JSON.stringify(model));
        }
      });
      // 处理循环数据
      let printTable = document.getElementById('printTable');
      // 先获取table一共有多少行
      let total = document.getElementById('printTable').rows.length;
      let index = 0;
      for (let i = 0; i < total; i++) {
        let span =
          document.getElementById('printTable').rows[i].cells[0].innerHTML;
        if (span.indexOf('{$') > -1) {
          index = i;
        }
      }
      for (let i = 0; i < that.printList.length; i++) {
        let circulate = document.getElementById('circulate').innerHTML;
        // 处理数据
        printKeyList.forEach((item) => {
          let name = '{$' + item.name + '}';
          let value = '';
          if (name.indexOf('图片') > -1) {
            value = that.printList[i][item.value]
              ? "<img style='height:40px' src='" +
              that.showImageUrl +
              that.printList[i][item.value] +
              "'/>"
              : '';
          } else {
            value = that.printList[i][item.value]
              ? that.printList[i][item.value]
              : '';
          }
          circulate = circulate.replaceAll(name, value);
        });
        getSysEntityExt(that.$root.sysEntityExt_1).forEach((item) => {
          let name = '{$' + item.name + '}';
          let value = '';
          switch (item.dataType) {
            case 'text':
              value = that.printList[i][item.value]
                ? that.printList[i][item.value]
                : '';
              break;
            case 'customSelect':
              value = that.printList[i][item.value]
                ? sysSelectDataShow(
                  that.printList[i][item.value],
                  item.selectOptionList
                )
                : '';
              break;
            default:
              break;
          }
          circulate = circulate.replaceAll(name, value);
        });
        let circulateTwo = printTable.insertRow(i + index + 1);
        circulateTwo.innerHTML = circulate;
      }
      printTable.deleteRow(index);
      that.htmlDataList += document.getElementById('printArea').innerHTML;
      // that.$refs.easyPrint.print();
    } catch (error) {
      console.error('打印异常：' + error);
      that.$message.error('打印异常：' + error);
    }
  });
}

var list = [
  'table',
  'pmgtPurchasesOrderDocDetailList',
  'smgtSalesQuotationDocDetailList',
  'salesDeliveryDocDetailList',
  'warehouseList', 'pmgtPurchasesChargebackDocDetailList',
  'purchasesRequistionDocDetailList',
  'salesSampleDocDetailList',
  'purchasesReceiptDocDetailList',
  'warehouseOtherDocDetailWithRelations',
  'mainList', 'outsorReturnDocDetailList', 'outsorRequisitionDocDetailList', 'produceDocProcessMaterials', 'processRouteDetails',
  'salesOrderDocDetailList', 'bomProcesses', 'bomProcesseMaterialList', 'smgtSalesChargebackDocDetailList', 'proddocRequisitionDocDetails', 'smgtAfterSalesRepairDocDetailList', 'proddocReturnDocDetailList'
];

function setData(datas) {
  return new Promise(async (resolve, reject) => {
    var indexs = 0
    Object.keys(datas).forEach(async key => {
      if (Array.isArray(datas[key])) {
        await datas[key].forEach((it, id) => {
          indexs++;
          try {
            it.index = id + 1;
            it.imageBaseUrl = projectConfig.imageBaseUrl;
            try {
              it.specifications = specListShow(
                JSON.parse(it.baseMaterialSpecDesc)
              );
            } catch (err) {
              it.specifications = '';
            }
            try {
              it.groupspecifications = specListShow(
                JSON.parse(it.baseSpecgroupDesc)
              );
            } catch (err) {
              it.groupspecifications = '';
            }
            try {
              it.baseMaterialImg = projectConfig.imageBaseUrl + it.baseImgUrl;
            } catch { }
            // try {
            //   it.baseMaterialImg = projectConfig.imageBaseUrl + it.baseImgUrl;
            // } catch {}
            try {
              if (!datas.baseMaterialName) {
                datas.baseMaterialName = it.baseMaterialName;
                datas.baseAmount = it.baseAmount;
                datas.specifications = it.specifications;
              }
            } catch { }
            try {
              var bs = JSON.parse(it.baseImgUrl ?? '[]');
              datas.imgs = '';
              bs.forEach((its) => {
                datas.imgs += projectConfig.imageBaseUrl + its.url + ',';
              });
              datas.imgUrl =
                bs.length > 0 ? projectConfig.imageBaseUrl + bs[0].url : '';
            } catch { }
            try {
              if (it.baseAmount) {
                datas.amountTotals += it.baseAmount;
                datas.totals += it.baseAmount * it.baseMaterialUnitprice;
              }
            } catch (err) {
              datas.amountTotals += 0;
              datas.totals += 0;
            }
            try {
              datas.baseSumMaterialAcountTotals += it.baseSumMaterialAcountTotal;
            } catch (err) {
              datas.baseSumMaterialAcountTotals = 0;
            }
            if (datas.table == null && Object.keys(it).length > 10) {
              datas.table = datas[key];
            }
            if (id == datas[key].length - 1) {
              resolve();
            }
          } catch (error) {
            console.error('setData', error)
            reject(error);
          } finally {
            resolve();
          }
        });
      }
    });
    setTimeout(() => {
      if (indexs == 0) {
        resolve();
      }
    }, 10);
  });
}

export function getNonObjectNonArrayItems(obj, result = {}) {
  if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
    return result;
  }
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      continue;
    }
    const value = obj[key];
    if (value === null || typeof value !== 'object' || Array.isArray(value)) {
      if (typeof value !== 'object' || value === null) {
        result[key] = value;
      }
    }
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      getNonObjectNonArrayItems(value, result);
    }
  }
  return result;
}

export async function printDataParse(data, isgroup = false) {
  return new Promise(async (resolve, reject) => {
    try {
      data.isgroup = isgroup;
      data.companyName = userinfo?.data?.gshowName;
      data.companyData = setCompanyData(userinfo?.data?.gshowName);
      data.totals = 0;
      data.amountTotals = 0;
      data.baseSumMaterialAcountTotals = 0;
      data.imageBaseUrl = projectConfig.imageBaseUrl;
      data.totalCap = '';
      data.date = data.createTime?.substring(0, 10) ?? ''
      try {
        if (data.baseDrawingFile) {
          data.baseDrawingFileList = JSON.parse(data.baseDrawingFile);
        }
        if (data.valueImgList) {
          data.valueImgLists = JSON.parse(data.valueImgList);
        } else {
          data.valueImgLists = []
        }
      } catch { }
      if (data.baseMaterialSpecDesc) {
        data.specifications = specListShow(JSON.parse(data.baseMaterialSpecDesc));
      }
      if (data.customerMaterialSpecDesc) {
        data.customerspecifications = data.customerMaterialSpecDesc;
      }
      if (data.materialCacheSpecList) {
        data.materialspecifications = specListShow(JSON.parse(data.materialCacheSpecList));
      }
      if (data.baseSpecgroupDesc) {
        data.groupspecifications = specListShow(JSON.parse(data.baseSpecgroupDesc));
      }
      try {
        if (data.baseImgUrl) {
          var ImgUrlList = JSON.parse(data.baseImgUrl)
          if (ImgUrlList.length > 0) { data.baseMaterialImg = projectConfig.imageBaseUrl + ImgUrlList[0].url; }
        }
      } catch { }
      const mainList = { ...data };
      setData(data)
        .then(() => {
          data.totalCap = convertToChineseMoney(data.totals);
          data.mainList = [mainList];
          if (isNaN(data.totals)) {
            data.totalCap = convertToChineseMoney(
              data.baseSumMaterialAcountTotals
            );
            data.totals = data.baseSumMaterialAcountTotals;
          }
          console.log('打印数据', data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      console.error('printDataParse', error)
    }
  });
}

/**
 * 将数字金额转换为大写中文金额的方法
 * @param {number|string} money - 要转换的数字金额
 * @returns {string} - 大写中文金额
 */
function convertToChineseMoney(money) {
  var cnNums = new Array(
    '零',
    '壹',
    '贰',
    '叁',
    '肆',
    '伍',
    '陆',
    '柒',
    '捌',
    '玖'
  ); // 汉字的数字
  var cnIntRadice = new Array('', '拾', '佰', '仟'); // 基本单位
  var cnIntUnits = new Array('', '万', '亿', '兆'); // 对应整数部分扩展单位
  var cnDecUnits = new Array('角', '分', '毫', '厘'); // 对应小数部分单位
  var cnInteger = '整'; // 整数金额时后面跟的字符
  var cnIntLast = '元'; // 整数完以后的单位
  // 最大处理的数字
  var maxNum = 999999999999999.9999;
  var integerNum; // 金额整数部分
  var decimalNum; // 金额小数部分
  // 输出的中文金额字符串
  var chineseStr = '';
  var parts; // 分离金额后用的数组，预定义
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    // 超出最大处理数字
    return '超出最大处理数字';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  // 四舍五入保留两位小数,转换为字符串
  money = Math.round(money * 100).toString();
  integerNum = money.substr(0, money.length - 2);
  decimalNum = money.substr(money.length - 2);
  // 获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        // 归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  // 小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

// function to(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//   成品 <input name="itemtype" type="checkbox"  class="radioLine" style="margin-right: 1.5em;"  ${value=="成品" ? 'checked' : ''}/>
//   半品 <input type="checkbox" class="radioLine" name="itemtype" ${value=="半品"  ? 'checked' : ''} />
//  </span>`
//   return str
// }
// function tos(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//     销售板 <input class="radioLine" name = "type" type = "radio" style="margin-right: 1.5em;"  ${!value ? '' : 'checked'}/>
//     测试板 <input class="radioLine" type="radio" name="type" ${!value ? 'checked' : ''} />
//    </span>`
//   return str
// }
// function toss(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//       本厂自费 <input class="radioLine" name = "money" type = "radio" style="margin-right: 1.5em;"  ${value =='本厂自费' ?'checked' : ''}/>
//       客户 <input class="radioLine" type="radio" name="money" style="margin-right: 1.5em;" ${value =='客户' ?'checked' : ''} />
//       其它 <input class="radioLine" type="radio" name="money" ${value =='其它' ?'checked' : ''} />
//      </span>`
//   return str
// }
// function tosss(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//         <input class="radioLine" name = "money" type = "checkbox" style=""  ${value =='手辦' ?'checked' : ''}/>
//         手辦 <input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${value =='Pro-E檔案' ?'checked' : ''}/>
//         Pro-E檔案  <input class="radioLine" type="checkbox" name="money" style="margin-left: 1em;" ${value =='AI档图片' ?'checked' : ''} />
//         AI档图片  <input class="radioLine" type="checkbox" name="money" style="margin-left: 1em;" ${value =='图纸' ?'checked' : ''} />
//         图纸  <input class="radioLine" type="checkbox" name="money" style="margin-left: 1em;" ${value =='其它：实物加图纸' ?'checked' : ''} />
//         其它：实物加图纸
//        </span>`
//   return str
// }
// function tossss(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//           <input class="radioLine" name = "money" type = "checkbox" style=""  ${value =='邮寄' ?'checked' : ''}/>
//           邮寄 <input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${value =='客户来厂验收自取' ?'checked' : ''}/>
//           客户来厂验收自取
//          </span>`
//   return str
// }
// function tosssss(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//             <input class="radioLine" name = "money" type = "checkbox" style=""  ${value =='客供' ?'checked' : ''}/>
//             客供 <input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${value =='供应商开发样品' ?'checked' : ''}/>
//             供应商开发样品<input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${value =='现大货物料' ?'checked' : ''}/>
//             现大货物料<input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${value =='其它：本厂' ?'checked' : ''}/>
//             其它：本厂
//            </span>`
//   return str
// }
// function formatters(data, options) {
//   return '<div style="height:50pt;width:50pt;background:red;border-radius: 50%;"></div>';
// }
// function ht(title, value, options, templateData, target) {
//   try {
//     value = value.split(",");
//     console.log(value)
//     let imagesHtml = '';
//     value.forEach(link => {
//       imagesHtml += `<div class="padding-xs"><img src="${link}" style="width:100%" /></div>`; // 拼接图片链接
//     });
//     return `<div class="grid col-4">
//               ${imagesHtml}</div>`
//   } catch {
//     return ""
//   }
// }
// function sc(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//   工程部 <input class="radioLine" name = "department" type = "radio" style="margin-right: 1.5em;"  ${!value ? 'checked' : ''}/>
//   生产部 <input class="radioLine" type="radio" name="department" style="margin-right: 1.5em;" ${!value ? 'checked' : ''} />
//   采购 <input class="radioLine" type="radio" name="department" ${!value ? 'checked' : ''} />
//   品检部 <input class="radioLine" type="radio" name="department" ${!value ? 'checked' : ''} />
//      </span>`
//   return str
// }
// function css(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//           <input class="radioLine" name = "money" type = "checkbox" style=""  ${!value ? '' : 'checked'}/>
//           客人签样 <input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${!value ? '' : 'checked'}/>
//           成品
//          </span>`
//   return str
// }
// function scss(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//         <input class="radioLine" name = "money" type = "checkbox" style=""  ${!value ? '' : 'checked'}/>
//         1.物料印花 <input class="radioLine" name = "money" type = "checkbox" style="margin-left: 1em;"  ${!value ? '' : 'checked'}/>
//         2.生产工艺   <input class="radioLine" type="checkbox" name="money" style="margin-left: 1em;" ${!value ? 'checked' : ''} />
//         3. 产品尺寸  <input class="radioLine" type="checkbox" name="money" style="margin-left: 1em;" ${!value ? 'checked' : ''} />
//         4.布标
//        </span>`
//   return str
// }

// function tos(title, value, options, templateData, target) {
//   var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//   销售板 <input class="radioLine" name = "type" type = "radio" style="margin-right: 1.5em;"  ${value.indexOf("销售")>=0?'checked':''}/>
//   测试板 <input class="radioLine" name = "type" type = "radio" style="margin-right: 1.5em;"  ${value.indexOf("测试")>=0?'checked':''}/>
//   生产板 <input class="radioLine" type="radio" name="type"  ${value.indexOf("生产")>=0?'checked':''} />
//  </span>`
//   return str }

//   function toss(title, value, options, templateData, target) {
//     value=value.trim()
//     var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
//         本厂自费 <input class="radioLine" name = "byPay" type = "radio" style="margin-right: 1.5em;"  ${value =='本厂自费' ?'checked' : ''}/>
//         客户 <input class="radioLine" type="radio" name="byPay" style="margin-right: 1.5em;" ${value =='客户' ?'checked' : ''} />
//         其它 <input class="radioLine" type="radio" name="byPay" ${value =='其它' ?'checked' : ''} />
//        </span>`
//     return str
//   }

// function ht(title, value, options, templateData, target) {
//   try {
//     value = value.split(",");
//     console.log(value)
//     let imagesHtml = '';
//     value.forEach(link => {
//       if(!link)return;
//       imagesHtml += `<div class="padding-xs"><img src="${link}" style="width:100%" /></div>`; // 拼接图片链接
//     });
//     return `<div class="grid col-4">
//               ${imagesHtml}</div>`
//   } catch {
//     return ""
//   }
// }

function toss(title, value, options, templateData, target) {
  value = value.trim();
  var str = `<span style="display:inline-block;grid-column-start: 2;grid-column-end: 4;">
  非急 <input class="radioLine" name = "byPay" type = "checkbox" style="margin-right: 1.5em;"  ${value == '非急' ? 'checked' : ''
    }/>
  正常 <input class="radioLine" type="checkbox" name="byPay" style="margin-right: 1.5em;" ${value == '正常' ? 'checked' : ''
    } />
  加急 <input class="radioLine" type="checkbox" name="byPay" ${value == '加急' ? 'checked' : ''
    } />
  紧急 <input class="radioLine" type="checkbox" name="byPay" ${value == '紧急' ? 'checked' : ''
    } />
  必保 <input class="radioLine" type="checkbox" name="byPay" ${value == '必保' ? 'checked' : ''
    } />
     </span>`;
  return str;
}

function formatter(title, value, options, templateData, target) {
  value = !value ? [{}] : value;
  value[0].baseDeliveryTime = !value[0].baseDeliveryTime
    ? ''
    : value[0].baseDeliveryTime;
  return '<div style="display:inline-block;grid-column-start: 2;grid-column-end: 99;height: 16;border-bottom: 1px solid #444;">\n              '.concat(
    value[0].baseDeliveryTime?.substr(0, 10),
    '&nbsp</div>'
  );
}

function loads(title, value, options, templateData, target) {
  templateData = templateData ?? {};
  return `
  <div style="height:100%;display: flex;justify-content: center;align-items: center; ">
  <table class="xltable" style="border-collapse: collapse; margin-left: auto; margin-right: auto;width:100%" border="1">
  <tr>  
      <td style="width:5em">项目号</td>  
      <td>${templateData.salesOrderDocNumber ?? ''}</td>  
  </tr>  
  <tr>  
      <td>单元号</td>  
      <td>${templateData.salesDeliveryDocNumber ?? ''}</td>  
  </tr>  
  <tr>  
      <td>规格型号</td>  
      <td>${templateData.specifications ?? ''}</td>  
  </tr>  
  <tr>  
      <td>品号</td>  
      <td>${templateData.baseMaterialNumber ?? ''}</td>  
  </tr>  
  <tr>  
      <td>数量</td>  
      <td>${templateData.baseAmount ?? ''}</td>  
  </tr>  
</table> 
</div>`
}
function s(title, value, options, templateData, target) {
  value = JSON.parse(value || '[]')
  templateData = templateData ?? {}
  var str = value.map(a => `<img src="${templateData.imageBaseUrl + a.url}" style="max-width:100%" />`)
  if (str.length == 0) { return '' } else { return str.join('<br>') }
}

function l(t, e, i, l) {
  return i && i['totalCap']
    ? `<tr><td style="padding:0 10px;text-align:right" colspan="4">合计 <td style="padding:0 10px" colspan="110">${i['totals']}</tr>
    <tr><td style="padding:0 10px;text-align:right" colspan="2">总金额（人民币） <td style="padding:0 10px" colspan="110">${i.totalCap} （含13%增值税）</tr>`
    : `<tr><td style="padding:0 10px;text-align:right" colspan="4">合计 <td style="padding:0 10px" colspan="110"></tr>
    <tr><td style="padding:0 10px;text-align:right" colspan="2">总金额（人民币） <td style="padding:0 10px" colspan="110"></tr>`
}
function st1(value, row, colIndex, options, rowIndex) {
  var position = 1
  var cnNums = new Array(
    '零',
    '壹',
    '贰',
    '叁',
    '肆',
    '伍',
    '陆',
    '柒',
    '捌',
    '玖'
  );
  var price = row?.baseMaterialTotalprice;
  if (price) {
    let numberStr = price.toString();
    var integerPart, decimalPart;
    if (numberStr.indexOf('.')) { [integerPart, decimalPart] = numberStr.split('.'); }
    var strs = numberStr.split('.')

    // 检查位置是否有效
    if (position < integerPart.length && position > 0) {
      var ret = integerPart.slice(0, position - 1) + integerPart.slice(position);
      if (ret) { return cnNums[Number(ret)] }
    }
    // 检查位置是否有效
    if (position < decimalPart.length && position < 0) {
      var ret = decimalPart.slice(0, position - 1) + decimalPart.slice(position);
      if (ret) { return cnNums[Number(ret)] }
    }
  }
  return '';
}
